import { ExcursionSelection } from '@/app/pages/excursion-selection/excursion-selection';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

const excursionSelectionSchema = z.object({
  cityId: z.string({ coerce: true }),
  cityName: z.string().optional(),
  regionName: z.string().optional(),
  timeZone: z.string(),
  arrivalDate: z.string(),
  departureDate: z.string(),
  adults: z.number(),
  childAges: z.array(z.number()).optional(),
  selectedExcursionId: z.string().optional(),
  excursionDrawer: z.boolean().optional(),
  travelId: z.string().optional(),
  bookingType: z.enum(['your-tour', 'accommodation', 'excursion']).optional(),
});

export const Route = createFileRoute('/excursion-selection/')({
  component: ExcursionSelection,
  validateSearch: excursionSelectionSchema,
});
